import React, { useState } from "react";

export default function AIFlightAssistant({ flight }) {
  const [messages, setMessages] = useState([
    {
      sender: "ai",
      text: `Bonjour 👋 ! Je suis votre assistant pour ce vol avec ( ${flight.itineraries[0].segments[0].carrierCode}). Vous pouvez me poser des questions sur cet itinéraire.`,
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const askAboutFlight = async (question) => {
    const res = await fetch("https://djatervoyage.com/backend_djatervoyage/ai/chatbase_proxy.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question: `${question}\n\nContexte du vol: ${JSON.stringify(flight)}`,
      }),
    });
    const data = await res.json();
    return data.output?.text || data.text || "Je n’ai pas compris votre question.";
  };

  const handleSend = async () => {
    if (!input.trim()) return;
    const question = input.trim();
    setMessages((m) => [...m, { sender: "user", text: question }]);
    setInput("");
    setLoading(true);

    try {
      const reply = await askAboutFlight(question);
      setMessages((m) => [...m, { sender: "ai", text: reply }]);
    } catch (err) {
      setMessages((m) => [...m, { sender: "ai", text: "Erreur serveur." }]);
    }

    setLoading(false);
  };

  return (
    <div className="mt-3 border-t pt-2">
      <div className="bg-blue-50 p-2 rounded-lg max-h-60 overflow-y-auto text-sm space-y-2">
        {messages.map((msg, idx) => (
          <div key={idx} className={msg.sender === "ai" ? "text-blue-700" : "text-gray-800 text-right"}>
            <span
              className={`inline-block px-2 py-1 rounded-xl ${
                msg.sender === "ai" ? "bg-white" : "bg-gray-100"
              }`}
            >
              {msg.text}
            </span>
          </div>
        ))}
        {loading && <div className="text-blue-400">L’assistant réfléchit...</div>}
      </div>

      <div className="flex gap-2 mt-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="flex-1 border rounded-lg px-2 py-1 text-sm"
          placeholder="Poser une question sur ce vol..."
          disabled={loading}
        />
        <button
          onClick={handleSend}
          className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm"
          disabled={loading}
        >
          Envoyer
        </button>
      </div>
    </div>
  );
}
